<script lang="ts">
	import { twMerge } from 'tailwind-merge';

	let { src, title, dataCy, navigating = undefined, ...rest }: Props = $props();

	interface Props {
		src: string;
		title: string;
		dataCy: string;
		navigating?: boolean | undefined;
		class?: string;
	}
</script>

<div {...rest} class={twMerge('relative', rest.class)}>
	{#if !navigating}
		<iframe
			{src}
			{title}
			data-cy={`${dataCy}-video-player`}
			allowfullscreen
			allowtransparency
			allow="autoplay"
			loading="lazy"
			class="absolute h-full w-full bg-[#efefef]"
		></iframe>
	{/if}
</div>
